import React, { FC } from 'react'

import i18n from 'modules/core/lib/i18n'

import { useItemProvider } from 'modules/processes/components/ItemWizard/Providers/item'
import { DataCollectionCategories } from 'modules/processes/domain'
import { TaskTypes } from 'modules/processes/hooks/types'

import TaskCard from '../../../../components/ItemCard'

interface Props {
  onSelect: (taskType: TaskTypes) => void
}

const Selector: FC<Props> = ({ onSelect }) => {
  const { itemType } = useItemProvider()

  return (
    <TaskCard
      title={i18n.t('processes.process_settings.wizard.tasks.types.additional_employee_info.title')}
      description={i18n.t(
        'processes.process_settings.wizard.tasks.types.additional_employee_info.description'
      )}
      onSelect={() => {
        onSelect(DataCollectionCategories.employee_questions_cf)
      }}
      itemType={DataCollectionCategories.employee_questions_cf}
      value={itemType}
    />
  )
}

export default Selector
